module.exports = __webpack_public_path__ + "static/media/2.1ee53c4d.jpg";